import type { MetadataPropertyInfo as MetadataPropertyInfoContract } from "../../contracts/utils/metadata/MetadataPropertyInfo";
import type { MetadataPropertyInfoType } from "../../contracts/utils/metadata/MetadataPropertyInfoType";

export class MetadataPropertyInfo<T>
	implements MetadataPropertyInfoContract<T>
{
	constructor(
		private readonly name: keyof T,
		private readonly types: MetadataPropertyInfoType[],
		private readonly optional: boolean,
	) {}

	getName(): keyof T {
		return this.name;
	}

	isOptional(): boolean {
		return this.optional;
	}

	matchProperty(value: unknown): boolean {
		for (const type of this.types) {
			if (type.matchType(value)) {
				return true;
			}
		}
		return false;
	}

	toString(): string {
		return `${String(this.name)}${this.isOptional() ? "?" : ""}: ${this.types.join("|")}`;
	}
}
